import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-booking-date-start',
    templateUrl: './editor-booking-item-setting-field-booking-date-start.component.html',
    styleUrls: ['./editor-booking-item-setting-field-booking-date-start.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldBookingDateStartComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;

  hourNames: { id: number, name: string }[];
  minuteNames: { id: number, name: string }[];

  constructor(private editorData: EditorDataService) {
    this.hourNames = this.editorData.hourNames;
    this.minuteNames = this.editorData.minuteNames;
  }

  ngOnInit() {

  }
}
